export default __webpack_public_path__ + "assets/webgl/scene-13.03ea539a.glb";